
import React from 'react';

interface IntroductionProps {
  data: {
    definisi: string;
    tujuan: string;
    obyek: string;
    hukum: string;
  };
}

const Introduction: React.FC<IntroductionProps> = ({ data }) => {
  const hijaiyah = "ا ب ت ث ج ح خ د ذ ر ز س ش ص ض ط ظ ع غ ف ق ك ل م ن و ه لا ء ي".split(" ");

  return (
    <div className="p-5 md:p-8 animate-fadeIn">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-black text-dark mb-2 tracking-tight">PENDAHULUAN</h2>
        <div className="h-1 w-16 bg-primary mx-auto rounded-full"></div>
      </div>

      <div className="space-y-6 md:space-y-8">
        <section className="bg-bg/50 p-6 rounded-2xl border-l-4 border-primary shadow-sm hover:shadow-md transition-all">
          <h3 className="font-bold text-xs text-primary mb-3 uppercase tracking-widest flex items-center gap-2">
            <i className="fa-solid fa-quote-left"></i> Definisi Ilmu Tajwid
          </h3>
          <p className="text-dark leading-relaxed text-base md:text-lg font-medium italic">"{data.definisi}"</p>
        </section>

        <section className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <div className="bg-white p-6 rounded-2xl border border-stroke shadow-sm hover:shadow-lg hover:border-primary/30 transition-all group">
            <h3 className="font-bold text-dark mb-4 flex items-center group-hover:text-primary transition-colors">
              <span className="bg-primary/10 text-primary w-10 h-10 rounded-xl flex items-center justify-center text-sm font-black mr-3">1</span>
              Tujuan Mempelajari
            </h3>
            <p className="text-body text-sm leading-relaxed ml-12">{data.tujuan}</p>
          </div>
          <div className="bg-white p-6 rounded-2xl border border-stroke shadow-sm hover:shadow-lg hover:border-primary/30 transition-all group">
            <h3 className="font-bold text-dark mb-4 flex items-center group-hover:text-primary transition-colors">
              <span className="bg-primary/10 text-primary w-10 h-10 rounded-xl flex items-center justify-center text-sm font-black mr-3">2</span>
              Obyek Pelajaran
            </h3>
            <p className="text-body text-sm leading-relaxed ml-12">{data.obyek}</p>
          </div>
        </section>

        <section className="bg-warning/10 p-6 rounded-2xl border border-warning/20">
          <h3 className="font-black text-warning mb-4 text-center uppercase tracking-widest text-xs">Hukum Tajwid</h3>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <div className="p-4 bg-white rounded-xl shadow-sm w-full md:w-5/12 text-center transform hover:scale-105 transition-transform">
              <span className="block font-black text-dark text-lg md:text-xl">Fardhu 'Ain</span>
              <span className="text-xs font-bold text-body uppercase tracking-wide">Membaca Al-Quran</span>
            </div>
            <div className="hidden sm:block text-warning font-black text-2xl px-2">/</div>
            <div className="p-4 bg-white rounded-xl shadow-sm w-full md:w-5/12 text-center transform hover:scale-105 transition-transform">
              <span className="block font-black text-dark text-lg md:text-xl">Fardhu Kifayah</span>
              <span className="text-xs font-bold text-body uppercase tracking-wide">Mempelajari Ilmunya</span>
            </div>
          </div>
        </section>

        <section className="pt-6 border-t border-stroke">
          <p className="text-body text-[10px] font-black uppercase tracking-[0.2em] text-center mb-6">Huruf Hijaiyah</p>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            {hijaiyah.map((char, idx) => (
              <div key={idx} className="w-10 h-10 md:w-12 md:h-12 bg-white border border-stroke rounded-xl flex items-center justify-center text-xl md:text-2xl text-primary arabic-font hover:bg-primary hover:text-white hover:scale-110 transition-all shadow-sm cursor-default">
                {char}
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Introduction;
